module.exports = __webpack_public_path__ + "img/fashion_85.fd45e446.jpg";